// 渠道一域名
const channelHm = ['hmtest.hzwxbz999.cn', 'hmpre.hzwxbz999.cn', 'hm.cqling.com', 'hm.yuwanf.com'];
// 渠道三域名
// const channelCw = ['hm.yxbdz14.com', 'hm.yxcgg63.com', 'hm.hnyuezan.com', 'hm.hnyuezan7.cn'];
const channelCw = [];
// 区分不同渠道
const getChannelType = function () {
  if (channelCw.includes(window.location.hostname)) {
    return 'channel_cw';
  } else {
    return 'channel_hm';
  }
};
// 获取appId.
const getAppId = function () {
  const channelType = getChannelType();
  if (channelType === 'channel_hm') {
    if (process.env.VUE_APP_IS_TEST) return 'wx06bcc1bbddea4e75';

    switch (window.location.hostname) {
      case 'hmtest.hzwxbz999.cn':
      case 'hmpre.hzwxbz999.cn':
      case 'heipre.xxinyou.cn':
        return 'wx06bcc1bbddea4e75';
      default:
        return 'wxee4e6b906258b68e';
    }
  }
  if (channelType === 'channel_cw') {
    return process.env.VUE_APP_IS_TEST ||
      window.location.hostname == 'hm.yxbdz14.com' ||
      window.location.hostname == 'hm.yxcgg63.com'
      ? 'wx06bcc1bbddea4e75'
      : 'wxee4e6b906258b68e';
  }
};
// 获取基础api地址
const getApiBaseurl = function (type) {
  const apiType = type ? type : 'api';
  // 测试环境
  if (process.env.VUE_APP_IS_TEST) {
    return `//hmapitest.hzwxbz999.cn/${apiType}/channel_hm`;
  }
  switch (window.location.hostname) {
    // 悦玩
    case 'hmtest.hzwxbz999.cn':
    case 'heitest.xxinyou.cn':
    case 'localhost':
      return `//hmapitest.hzwxbz999.cn/${apiType}/channel_hm`;
    case 'hmpre.hzwxbz999.cn':
    case 'heipre.xxinyou.cn':
      return `//hmapipre.hzwxbz999.cn/${apiType}/channel_hm`;
    case 'hm.cqling.com':
      return `//hmapi.hzwxbz3.cn/${apiType}/channel_hm`;
    case 'hm.hzwxbz3.cn':
      return `//hmapi.hzwxbz3.cn/${apiType}/channel_hm`;
    // // 渠道三
    // case 'hm.yxbdz14.com':
    //   return `//hmapitest.hzwxbz999.cn/${apiType}/channel_cw`;
    // case 'hm.yxcgg63.com':
    //   return `//hmapipre.hzwxbz999.cn/${apiType}/channel_cw`;
    // case 'hm.hnyuezan.com':
    //   return `//hmapi.hzwxbz3.cn/${apiType}/channel_cw`;
    // case 'hm.hnyuezan7.cn':
    //   return `//hmapi.hzwxbz3.cn/${apiType}/channel_cw`;
    // 默认线上悦玩地址
    default:
      return `//hmapi.hzwxbz3.cn/${apiType}/channel_hm`;
  }
};

// 微信在线玩游戏api
const getSdkApi = function () {
  switch (window.location.hostname) {
    // 悦玩
    case 'hmtest.hzwxbz999.cn':
      return '//apirm.52ywan.com';
    case 'hmpre.hzwxbz999.cn':
      return '//h5.680game.cn';
    // // 渠道三
    // case 'hm.yxbdz14.com':
    //   return '//apirm.52ywan.com';
    // case 'hm.yxcgg63.com':
    //   return '//h5.680game.cn';
    default:
      return '//h5.hzwxbz3.cn';
  }
};
// cdn基础地址
export const CDN_URL = '//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform';
// 区分渠道类型
export const channelType = getChannelType();
// appId
export const appId = getAppId();
// 通用接口基础路径
export const API_URL = getApiBaseurl();
// 秒杀活动接口基础路径
export const ACT_API_URL = getApiBaseurl('act');
// 工单系统
export const SDK_API_URL = getSdkApi();
